import styled from 'styled-components';

import { getSpacing } from 'stylesheetB2c';

import { MessageText } from '../../Message.style';

export const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;
StyledContainer.displayName = 'StyledContainer';

export const StyledMessage = styled(MessageText)`
  margin-bottom: ${getSpacing(8)};
`;
StyledMessage.displayName = 'StyledMessage';

export const LinksContainer = styled.div`
  width: ${getSpacing(73)};
  display: flex;
  justify-content: space-between;
`;
LinksContainer.displayName = 'LinksContainer';
